export default class AutomationEmailCtrl {
    constructor($scope, $filter, $window, $rootScope, $stateParams, $state, $q, SideMenu, Rest, Tag, Setting, Segment, Events, SweetAlert, Automation) {
        SideMenu.setActive('automation');

        this._scope = $scope;
        this._filter = $filter;
        this._window = $window;
        this._rootScope = $rootScope;
        this._stateParams = $stateParams;
        this._state = $state;
        this._q = $q;
        
        this.rest = Rest.rest;
        this.tagRepo = Tag;
        this.settingRepo = Setting;
        this.segmentRepo = Segment;
        this.eventsHandler = Events;
        this.sweetAlert = SweetAlert;
        this.automationRepo = Automation;

        this.dispatcherType = 'automation';

        this.segmentRepo.all().then((result) => {
            this.activeSegments = result.data;
            this._scope.$broadcast('mailEditor:segments:fetched', this.activeSegments);
        });

        this.tagRepo.all().then((result) => {
            this.activeTags = result.data;
            this._scope.$broadcast('mailEditor:tags:fetched', this.activeTags);
        });

        this.automationRepo.find(this._stateParams.id).then((automation) => {
            this.dispatcher.active = automation.data.active;
        });

        this.preview = {
            to: this._window.localStorage.getItem('preview_to') ? this._window.localStorage.getItem('preview_to') : null
        };

        this.dispatcher = {
            id: this._stateParams.id,
            email: {
                id: null,
                from_name: '',
                from_email: '',
                subject: '',
                email_template_id: 0,
                language: null,
                ga_utm_campaign: ''
            }
        };

        this.settingRepo.findSenderDetail().then((details) => {
            this.hasGaDomains = details.google_analytics_domains.length > 0;
        });
        if (this._stateParams.emailId) {
            this.templateSelected = true;
            this.automationRepo.findEmail(this._stateParams.id, this._stateParams.emailId).then((response) => {
                this.dispatcher.email = angular.copy(response.data);
                this.htmlSource = "automail/" + this._stateParams.id + "/email/" + this._stateParams.emailId + "/htmlContent";
                this.plainSource = "automail/" + this._stateParams.id + "/email/" + this._stateParams.emailId + "/plainContent";

                this._rootScope.$broadcast('mailEditor:state:init', {
                    dispatcher: this.dispatcher,
                    dispatcherType: this.dispatcherType,
                    htmlSource: this.htmlSource,
                    plainSource: this.plainSource,
                    templateId: this.dispatcher.email.email_template_id
                });
            });
        } else {
            this.htmlSource = null;

            this.settingRepo.findSenderDetail().then((details) => {
                this.dispatcher.email.from_name = details.company || details.name;
                this.dispatcher.email.from_email = details.email;
                this._rootScope.$broadcast('mailEditor:templateSelector:show');
            })
        }

        this._scope.$on('mailEditor:template:selected', (event, templateId) => {
            this.htmlSource = 'template/' + templateId + '/htmlContent';
            this.dispatcher.email.email_template_id = templateId;
            this._scope.$broadcast('mailEditor:state:init', {
                dispatcher: this.dispatcher,
                dispatcherType: this.dispatcherType,
                htmlSource: 'template/' + templateId + '/htmlContent',
                plainSource: 'template/' + templateId + '/plainContent',
                templateId: this.dispatcher.email.email_template_id
            });
            this.templateSelected = true;
        });

        this._scope.$on('mailEditor:template:notChanged', () => {
            this.templateSelected = true;
        });

        this._scope.$on('mailEditor:setLanguage', (event, language) => {
            this.dispatcher.email.language = {data: { code: language }};
        });

        this._scope.$on('account:changed', () => {
            this._state.go('automation.index');
        });

    }

    newTemplate() {
        this.templateSelected = false;
        this._scope.$broadcast('mailEditor:templateSelector:show');
    };

    isValidUtm(utm) {
        return true;
        var regexp = /^[a-zA-Z0-9_]*$/;
        if (regexp.test(utm)) {
            return true;
        } else {
            return false;
        }
    };

    validSender() {
        return this.dispatcher.email.from_name.length > 0 && this.dispatcher.email.from_email;
    };

    validSubject() {
        return this.dispatcher.email.subject.length > 0;
    };

    validPreview() {
        var returnArray = [];

        if (! this.preview.to) {
            returnArray.push(this._filter('translate')('CAMPAIGN:FLASH:PREVIEW_RECIPENT_ERROR'));
        } if (! this.validSender()) {
            returnArray.push(this._filter('translate')('CAMPAIGN:FLASH:INVALID_SENDER'));
        } if (! this.validSubject()) {
            returnArray.push(this._filter('translate')('CAMPAIGN:FLASH:INVALID_SUBJECT'));
        }

        return returnArray;
    };

    validCheck(error, deferred) {
        if (error.status == 400 && error.data.error == 'ValidationError') {

            // Loop through each error.
            angular.forEach(Object.keys(error.data.message), (validationError) => {
                if (validationError == 'email.from_email') {
                    this.eventsHandler.flashEvent('error', this._filter('translate')('MAILEDITOR:FLASH:INVALID_FROM_EMAIL'));
                } else if (validationError == 'email.subject') {
                    this.eventsHandler.flashEvent('error', this._filter('translate')('CAMPAIGN:FLASH:INVALID_SUBJECT'));
                } else if (validationError == 'email.from_name') {
                    this.eventsHandler.flashEvent('error', this._filter('translate')('MAILEDITOR:FLASH:INVALID_FROM_NAME'));
                } else if (validationError == 'email.plain_content') {
                    this.eventsHandler.flashEvent('error', this._filter('translate')('MAILEDITOR:FLASH:EMPTY_PLAIN_CONTENT'));
                }
            });

            return deferred.reject();
        }
    };

    sendPreview() {

        if (this.validPreview().length > 0) {
            var message = '';

            angular.forEach(this.validPreview(), (value, index) => {
                message += value + '\n';
            });

            return this.sweetAlert.swal({
                title: 'Error',
                text: message,
                type: 'error'
            });
        }

        this.save().then(() => {
            this.rest.all('email').all('preview').post({
                email_id: this.dispatcher.email.id,
                preview_to: this.preview.to
            }).then(() => {
                this.eventsHandler.flashEvent('notification', this._filter('translate')('CAMPAIGN:FLASH:PREVIEW'))
            }, (error) => {
                if (error.status == 400) {
                    this.sweetAlert.swal({
                        title: 'Error',
                        text: this._filter('translate')('CAMPAIGN:FLASH:PREVIEW_RECIPENT_FORMAT_ERROR'),
                        type: 'error'
                    });
                } else {
                    this.sweetAlert.swal({
                        title: 'Error',
                        text: this._filter('translate')('CAMPAIGN:FLASH:PREVIEW_ERROR'),
                        type: 'error'
                    });
                }
            })
        })
    };

    validTfs() {
        return this.validSender() && this.validSubject()
    };

    toIndex() {
        this._state.go('automation.folder', { folder: this.dispatcher.active ? 'active' : 'inactive' });
    };

    save() {
        let htmlContent, plainContent;
        this._rootScope.$broadcast('settings:applyHTMLSettings');
        var deferred = this._q.defer();
        this._scope.$broadcast('mailEditor:state:saving');

        if (! this.isValidUtm(this.dispatcher.email.ga_utm_campaign)) {
            this.eventsHandler.flashEvent('error', this._filter('translate')('CAMPAIGN:SUMMARY:TRACKING_ERROR'));
            return;
        }

        this._scope.$broadcast('mailEditor:prepareHtml', (content) => {
            htmlContent = content;
            this._scope.$broadcast('plainEditor:getContent', (plain) => {
                plainContent = plain;
                this.dispatcher.email.html_content = htmlContent;
                this.dispatcher.email.plain_content = plainContent;
                this.dispatcher.name = this.dispatcher.email.subject;
            });
        });
        if (this.dispatcher.email.id === null) {
            this.automationRepo.createEmail(this.dispatcher.id, this.dispatcher.email).then((response) => {
                this.dispatcher.email = response.data;
                this.eventsHandler.flashEvent('notification', this._filter('translate')('AUTOMATION:FLASH:CREATED'));

                this._state.go('automation.emailEdit', { id: this.dispatcher.id, emailId: this.dispatcher.email.id });
                deferred.resolve()
            }, (error) => {
                this.validCheck(error, deferred);
            })
        } else {
            this.automationRepo.saveEmail(this._stateParams.id, this.dispatcher.email).then((response) => {
                this.dispatcher.email = response.data;
                this.eventsHandler.flashEvent('notification', this._filter('translate')('AUTOMATION:FLASH:SAVED'));
                this._rootScope.$broadcast('dispatcher:updated');
                deferred.resolve();
            }, (error) => {
                this.validCheck(error, deferred);
            })
        }

        return deferred.promise;
    }

    toggleImageBank() {
        this.imageBankVisible = ! this.imageBankVisible;
        this._scope.$emit('imageBank:toggle');
    }
}
